import { render, staticRenderFns } from "./FaqsPage.vue?vue&type=template&id=8ac9d676&scoped=true&"
import script from "./FaqsPage.vue?vue&type=script&lang=js&"
export * from "./FaqsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac9d676",
  null
  
)

export default component.exports